import { render, staticRenderFns } from "./ProjectEditProperties.vue?vue&type=template&id=d5fc1840"
import script from "./ProjectEditProperties.vue?vue&type=script&lang=ts"
export * from "./ProjectEditProperties.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5fc1840')) {
      api.createRecord('d5fc1840', component.options)
    } else {
      api.reload('d5fc1840', component.options)
    }
    module.hot.accept("./ProjectEditProperties.vue?vue&type=template&id=d5fc1840", function () {
      api.rerender('d5fc1840', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/ProjectEditProperties.vue"
export default component.exports